module.exports = __webpack_public_path__ + "b779497312bc090bb75ccd82b7c8fe38.fbx";